import { useMemo } from 'react';
import { useSubscription } from '~/src/entities/subscription';
import { canOrgUseFeatureAccess, getOrg } from '~/src/entities/user';
import { getRegion, Region } from '~/src/regions/config/utils';

export const useContentPackageWizardRedirect = () => {
  const { data: subscriptionData } = useSubscription();
  const region = getRegion();
  const org = getOrg();
  const isAdmin = org?.admin;
  const currentPath = window.location.pathname;

  const shouldRedirect = useMemo(() => {
    if (region !== Region.US) return false;

    if (!subscriptionData || !isAdmin) return false;

    if (
      currentPath.includes('content-package-wizard') ||
      currentPath.includes('welcome')
    ) {
      return false;
    }

    const isCbsSubscription = canOrgUseFeatureAccess('CBS_INTEGRATION', org);
    const contentPackagesWizardRan =
      subscriptionData.content_packages_wizard_ran;
    const contentPackagesPurchased =
      subscriptionData.content_packages_purchased;

    return (
      isCbsSubscription &&
      contentPackagesWizardRan === false &&
      contentPackagesPurchased > 0
    );
  }, [subscriptionData, currentPath, org, isAdmin, region]);

  return shouldRedirect;
};

export default useContentPackageWizardRedirect;
